export function MinutesTest(ctime){
    ctime = ctime.replace(/-/g, "/");//兼容ios
    var time = new Date(ctime);
    time.setMinutes (time.getMinutes () + 30);
    return time.getTime();
}
export function timestamp(ctime){
    ctime = ctime.replace(/-/g, "/");//兼容ios
    var time = new Date(ctime);
    return time.getTime();
}
export function day(ctime){
    ctime = ctime.slice(6).replace(/-/g, "/");//兼容ios
   
    return ctime;
}